import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import styles from "./ModalProductImages.module.scss";

const ModalProduct = (props) => {
  const {
    imgName,
    comingSoon,
    onCreateDesign,
    labelTag,
    family,
    product,
    minQty,
  } = props;

  const { t } = useTranslation();

  return (
    <div
      className={classNames(
        styles.container,
        comingSoon ? null : styles.containerSelectable
      )}
      onClick={
        !comingSoon
          ? () => onCreateDesign(family, product, t(labelTag))
          : () => {}
      }
    >
      <div className={styles.itemImage}>
        <img src={imgName} alt={t(labelTag)} />
      </div>
      <div className={styles.itemText}>
        <span
          className={classNames(
            styles.itemTextTitle,
            comingSoon ? styles.itemTextComingSoon : null
          )}
        >
          {t(labelTag)}
        </span>
        {!comingSoon && (
          <span className={styles.itemTextComingSoon}>
            {t("products.modal.minimum_qty", { minQty: minQty })}
          </span>
        )}
        {comingSoon && (
          <span className={styles.itemTextComingSoon}>
            {t("products.modal.coming")}
          </span>
        )}
      </div>
    </div>
  );
};

export default ModalProduct;
